import { render, staticRenderFns } from "./TabBlacklist.vue?vue&type=template&id=655a54d3"
import script from "./TabBlacklist.vue?vue&type=script&lang=js"
export * from "./TabBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports